import { useState } from 'react';
import { TrackOrdersection } from './styled';

export default function TrackOrder(props) {
  const { trackOrderHandler } = props;
  const [lowOpacity, setLowOpacity] = useState('');
  return (
    <TrackOrdersection
      track
      className={lowOpacity}
      onClick={(e) => {
        setLowOpacity('low');
        setTimeout(() => {
          trackOrderHandler(e);
        }, 100);
        setTimeout(() => {
          setLowOpacity('');
        }, 2000);
      }}
    >
      <p>My Orders</p>
      <img
        src="https://images.myloapp.in/NestJsUploads/1706531216096-my-orders-sidedrawer.svg"
        alt=""
      />
    </TrackOrdersection>
  );
}
